import React from "react";
import ProjectItem from "../components/ProjectItem";
import { projectList } from "../helpers/projectList";
import "../styles/Projects.css";

function Projects() {
  return (
    <div className="projects">
      <h1> My Personal Projects</h1>
      <div className="projectList">
        {projectList.map((project, index) => {
          return <ProjectItem name={project.name} image={project.image} index={index} />
        })}
      </div>
    </div>
  );
}

export default Projects;